import { CancelationReason, CancelationUserType, SupplyCondition } from '@caresend/types';
import { arrayToObj, nullishFilter } from '@caresend/utils';
import 'firebase/auth';
import { setProcedureStatusesRequest } from '../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../database/firebaseConfig/init.js';
import '../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import { toastSuccess, toastError } from '../../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../ui/Icon.vue.js';
import '../../../../functions/configuration/icons.js';
import '../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../functions/tracking/index.js';
import '../../../../router/helpers/initRouter.js';
import { getStore } from '../../../../store/helpers/initStore.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';

const isCancelationReason = (reason) => Object.values(CancelationReason).includes(reason);
const isCancelationUserType = (userType) => Object.values(CancelationUserType).includes(userType);
const isSupplyCondition = (supplyCondition) => Object.values(SupplyCondition).includes(supplyCondition);
const saveProceduresStatus = async (params) => {
    var _a;
    try {
        const { procedureIDs, reasonSelected, status, supplyConditionSelected, userTypeSelected, detailedReason, } = params;
        const store = getStore();
        const officeType = (_a = store.state.office.office) === null || _a === void 0 ? void 0 : _a.type;
        const procedureCanceled = await setProcedureStatusesRequest({
            procedureIDs,
            status,
            officeType,
            canceled: {
                detailedReason,
                reason: reasonSelected,
                supplyCondition: supplyConditionSelected,
                userType: userTypeSelected,
            },
        });
        const newProcedures = arrayToObj(procedureIDs.map((procedureID) => {
            const procedure = store.state.procedures.procedures[procedureID];
            if (!procedure)
                return undefined;
            return {
                ...procedure,
                status,
                procedureCanceled,
            };
        }).filter(nullishFilter), 'id');
        store.commit('procedures/SET_PROCEDURES', newProcedures);
        toastSuccess('Procedure status updated');
    }
    catch (error) {
        toastError(error);
    }
};

export { isCancelationReason, isCancelationUserType, isSupplyCondition, saveProceduresStatus };
